import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import { Phone } from 'lucide-react';

const YatraMain = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const cities = [
    { name: 'Chandigarh' },
    { name: 'Mohali' },
    { name: 'Rajpura' }
  ];

  const handleViewRoutes = (cityName) => {
    navigate(`/yatra/${cityName?.toLowerCase()}`);
  };

  return (
    <>
      <SEO
        title="Yatra Packages - Religious Tour Packages | Advait Tour and Travels"
        description="Book yatra packages from major cities. Comfortable pilgrimage travel with professional drivers and well-maintained vehicles."
        keywords="yatra packages, religious tour packages, pilgrimage travel, hemkund sahib yatra, nanded yatra"
        canonicalUrl={`${window.location?.origin}/yatra`}
        ogTitle="Yatra Packages - Religious Tour Packages | Advait Tour and Travels"
        ogDescription="Book yatra packages from major cities. Comfortable pilgrimage travel with professional drivers and well-maintained vehicles."
        ogUrl={`${window.location?.origin}/yatra`}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "TravelAgency",
          "name": "Advait Tour and Travels",
          "description": "Yatra packages for religious travel"
        }}
      />

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="py-20">
          {/* Hero Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-16 mb-12">
            <div className="container mx-auto px-4">
              <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
                Yatra Packages
              </h1>
            </div>
          </div>

          {/* City Cards */}
          <div className="container mx-auto px-4 mb-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
              {cities?.map((city, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6"
                >
                  <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">
                    {city?.name}
                  </h3>
                  <button
                    onClick={() => handleViewRoutes(city?.name)}
                    className="w-full py-3 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold rounded-lg transition-colors duration-300"
                  >
                    VIEW ROUTES
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Contact Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-12">
            <div className="container mx-auto px-4 text-center">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                We're here for you 24/7!
              </h2>
              <p className="text-xl text-white mb-6">
                Give us a call anytime
              </p>
              <a
                href="tel:+917998666660"
                className="inline-flex items-center gap-3 px-8 py-4 bg-white text-blue-600 font-bold text-2xl rounded-full hover:bg-gray-100 transition-colors duration-300"
              >
                <Phone className="w-6 h-6" />
                +91-79986-66660
              </a>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default YatraMain;